import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { IdentityService } from "../identity.service";
import { Identity, Header } from "@aptsi-types";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { MatDialog } from '@angular/material/dialog';
import { DeleteDialogComponent } from "src/app/shared/dialogs/delete-dialog/delete-dialog.component";



@Component({
  selector: 'app-identity-search',
  templateUrl: './identity-search.component.html',
  styleUrls: ['./identity-search.component.scss']
})
export class IdentitySearchComponent implements OnInit {

  // Pagination
  currentPage = 1;
  itemsPerPage = 7;
  totalPages = 0;

  // Search
  searchText = '';
  filterByHeader: string = "all";
  isSearch = false;
  searchTextChanged = new Subject<string>();

  // Data
  filteredData: Identity[] = [];
  searchedData: Identity[] = [];

  headers: Header[] = [
    { name: 'ID', property: 'fabricUsersId', showInDropdown: true },
    { name: 'Digital ID', property: 'digitalId', showInDropdown: true },
    { name: 'Username', property: 'username', showInDropdown: true },
    { name: 'Role', property: 'role', showInDropdown: true },
    { name: 'Organization', property: 'affiliation', showInDropdown: true },
    { name: 'Status', property: 'enrollmentStatus', showInDropdown: true },
    { name: 'Created', property: 'createdAt', showInDropdown: true }
  ];

  buttonConfig = {
    update: true,
    delete: true,
    revoke: false
  };

  constructor(
    private identityService: IdentityService,
    private router: Router,
    private dialog: MatDialog

  ) { }

  ngOnInit(): void {
    this.fetchIdentities();

    this.searchTextChanged
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => this.searchIdentities());
  }

  // Pagination getter
  get paginatedData(): Identity[] {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    return this.isSearch
      ? this.searchedData.slice(start, end)
      : this.filteredData.slice(start, end);
  }

  changePage(page: number): void {
    this.currentPage = page;
    this.isSearch ? this.searchIdentities() : this.fetchIdentities();
  }

    resetSearchText(): void {
    this.searchText = "";
    this.isSearch = false; // Switch to normal mode
    this.currentPage = 1; // Reset to the first page of normal data
  }

  // Fetch
  fetchIdentities(): void {
    this.identityService.getIdentities(this.currentPage - 1)
      .subscribe((res: any[]) => {
        console.log("API RESPONSE:", res);
        this.filteredData = res['Resource retrieved successfully'];
        console.log("response : ", this.filteredData);
        this.totalPages = res[0]?.totalPages || 1;
      });
  }

  searchIdentities(): void {
    if (!this.searchText) {
      this.isSearch = false;
      this.fetchIdentities();
      return;
    }

    this.isSearch = true;
    this.currentPage = 1;

    this.identityService
      .searchIdentities(this.currentPage - 1, this.searchText, this.filterByHeader)
      .subscribe((res: any[]) => {
         this.searchedData = res;
        this.totalPages = res[0]?.totalPages || 1;
      });
  }

  onSearchTextChange(value: string): void {
    this.searchTextChanged.next(value);
  }

  // Actions
  handleAction(event: any): void {
    const row = event.rowData;

    if (event.action === "update") {
      this.router.navigate(['secure-blockchain/auth-tools/identity/update', row.fabricUsersId]);
    }

    else if (event.action === "delete") {

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '400px',
        data: {
          title: 'Delete Smart Contract',
          message: `Are you sure you want to disable "${row.username}"?`
        }
      });

      dialogRef.afterClosed().subscribe((confirmed: boolean) => {

        this.identityService.revokeIdentity(row.fabricUsersId)
          .subscribe(() => {
            this.refresh();
          });
      });
    }

    else if (event.action === "revoke") {
      this.identityService.revokeIdentity(row.id).subscribe(() => {
        this.refresh();
      });
    }
  }

  addIdentity(): void {
    this.router.navigate(['secure-blockchain/auth-tools/identity/create']);
  }

  back(): void {
    if (this.isSearch) {
      this.isSearch = false;
      this.fetchIdentities();
    } else {
      this.router.navigate(['secure-blockchain/auth-tools']);
    }
  }

  refresh(): void {
    this.isSearch ? this.searchIdentities() : this.fetchIdentities();
  }

  // Mapping
  // mapData(users: any[]): Identity[] {
  //   return users.map(u => ({
  //     id: u.fabricUsersId,
  //     digitalId: u.digitalId,
  //     username: u.username,
  //     role: u.role,
  //     affiliation: u.affiliation,
  //     status: this.mapStatus(u.enrollmentStatus),
  //     createdOn: u.createdAt
  //   }));
  // }

  mapStatus(status: string): 'Active' | 'Pending' | 'Revoked' {
    switch (status) {
      case 'ENROLLED': return 'Active';
      case 'CREATED':
      case 'REGISTERED': return 'Pending';
      default: return 'Revoked';
    }
  }
}